import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationService } from 'app-components';
import moment from 'moment';
import { AppSettingsService } from 't4-app-integration';
import { CampaignInfo, PageBase } from 't4core';

@Component({
  selector: 'app-campaign-card',
  templateUrl: './campaign-card.html',
  styleUrls: ['./campaign-card.css'],
  standalone: false
})

export class CampaignCardComponent extends PageBase implements AfterViewInit {

  @Input() public campaign: CampaignInfo;
  @Input() public historical: boolean;

  public currentTime: moment.Moment = moment();

  constructor(
    el: ElementRef,
    public appSettings: AppSettingsService,
    private navigationService: NavigationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(el);
  }
  ngAfterViewInit(): void {

  }

  public async activate() {
    if (this.campaign.PartnerOfferType == 1) {
      var x = await this.UI.confirm("Intellitrailer.MyPage.CampaignCard.ConfirmActivation.Headline", "Confirm Activation", "Intellitrailer.MyPage.CampaignCard.ConfirmActivation.Message2", "Are you sure that you want to activate it?  Be prepared to display it to staff right away, as it cannot be activated more than once.");
      if (x) {
        this.navigationService.executeCommand("Details", { discountCode: this.campaign.DiscountCode });
      }
    }
    else if (this.campaign.PartnerOfferType == 2 || this.campaign.PartnerOfferType == 3) {
      if (this.campaign.ExternalCode != null || this.campaign.ExternalCode != "") {
        //var x = await this.UI.confirm("Intellitrailer.MyPage.CampaignCard.ConfirmRedirection.Headline", "Open in your browser?", "Intellitrailer.MyPage.CampaignCard.ConfirmActivation.Message3", "You’re about to open this link in your web browser. Would you like to continue?");
        //if (x) {
          window.open(this.campaign.ExternalCode, '_blank', 'noopener,noreferrer');
   /*     }*/
      }
      //else {
      //  var x = await this.UI.confirm("Intellitrailer.MyPage.CampaignCard.ConfimDismiss.Headline", "Dismiss?", "Intellitrailer.MyPage.CampaignCard.ConfirmActivation.Message4", "You’re about to dismiss this offer. Would you like to continue?");
      //  if (x) {
          
      //  }
      //}
    }
  }
}

